
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import ReasonDialog, { AddReasonDialog } from './addReasonDialog.vue'
import { ClueService } from '@/services'

/**
 *
 * @prop reasons     原因列表
 *
 */
@Component({
    name: 'reportedDialog',
    components: {
        ReasonDialog
    }
})
export default class extends Vue {
    @Prop({ required: true }) private reasons: any
    @Prop({ required: true }) private fetchReasons: any 

    @Ref('reasonDialogRef') private reasonDialog!: AddReasonDialog

    private dialogVisible = false
    private editDialogVisible = false
    private status = ''
    private curReason = { id: 0, name: '' }

    private onConfirmChange() {
        this.$emit('change', this.status)
    }

    private show() {
        this.dialogVisible = true
    }

    private hide() {
        this.dialogVisible = false
    }

    private reset() {
        this.status = ''
    }

    private onEdit() {
        this.editDialogVisible = true
    }

    private onUpdateReason(reason: any) {
        this.curReason = reason
        this.reasonDialog.show(reason.name, 'update')
    }

    private onDeleteReason(reason: any) {
        this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteReason(reason)
        })        
    }

    private async onAddReason(name: string) {
        const params = { name }
        const result = await ClueService.addNotPassReason(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '新增成功',
                showClose: true
            })
            this.reasonDialog.hide()
            await this.fetchReasons()
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        }) 
    }

    private async updateReason(name: string) {
        if (!this.curReason.id) return
        const params = { id: this.curReason.id, name }
        const result = await ClueService.editNotPassReason(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '修改成功',
                showClose: true
            })
            this.reasonDialog.hide()
            this.curReason.name = name
            this.reasonDialog.hide()
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    private async deleteReason(reason: any) {
        const params = { id: reason.id }
        const result = await ClueService.deleteNotPassReason(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            await this.fetchReasons()
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }
}
